export default "__VITE_ASSET__VnUaIKsr__"